import { Select } from "@mantine/core";
import { useContext } from "react";
import { LanguageContext } from "../contexts/app-context";
import { useTranslation } from "../hooks/translation-hook";
import { isLanguage, Language } from "../types/types";
import { texts } from "../texts/texts";

export function SelectLanguage({ setLanguage }: { readonly setLanguage: (language: Language) => void }): JSX.Element {
  const translate = useTranslation();
  const language = useContext(LanguageContext);

  return (
    <Select
      size="sm"
      aria-label="Select language"
      w={{ base: "100%", sm: 180 }}
      styles={{
        input: {
          backgroundColor: "#ffffff",
          borderColor: "#c9ced4",
        },
      }}
      data={[
        { value: "en_GB", label: translate(texts.english) },
        { value: "sv_SE", label: translate(texts.swedish) },
      ]}
      value={language}
      onChange={(value) => {
        if (value && isLanguage(value)) {
          setLanguage(value);
        }
      }}
    />
  );
}
